import React from 'react'

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Privacy Policy
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Your privacy and data security are our top priorities.
          </p>
        </div>
        
        <div className="card">
          <div className="py-12">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Data Handling
            </h3>
            <p className="text-gray-600 mb-6">
              SnapTools processes your files locally in your browser and on Cloudflare's 
              secure edge network. We do not permanently store your files, and all 
              uploaded content is automatically deleted within 1 hour.
            </p>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Security Measures
            </h3>
            <ul className="text-gray-600 space-y-2 mb-6">
              <li>• All file transfers use HTTPS encryption</li>
              <li>• Files are processed in secure, isolated environments</li>
              <li>• Automatic file deletion within 1 hour</li>
              <li>• No user tracking or data collection</li>
              <li>• GDPR compliant processing</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Contact
            </h3>
            <p className="text-gray-600">
              If you have any questions about our privacy practices, 
              please contact us at privacy@snaptools.example.com
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Privacy
